import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'

const Style = styled.div`
  margin-right: 35px;
  margin-bottom: 30px;
  display: inline-block;
  label {
    display: block;
    font-size: 14px;
  }
  input,
  textarea {
    background: ${(props) => props.theme.lightGray};
    border: none;
    display: inline-block;
    outline: none;
    transition: all 0.3s;
    width: 200px;
    @media (max-width: 600px) {
      width: 85vw;
    }
  .input {
    background: ${(props) => props.theme.lightGray};
    border: none;
    display: inline-block;
    outline: none;
    transition: all 0.3s;
    width: 200px;
    @media (max-width: 600px) {
      width: 85vw;
    }

    border-bottom: 2px solid ${(props) => props.theme.gray};
    &:focus {
      border-bottom: 2px solid ${(props) => props.theme.orange};
    }
  }
  input {
    height: 20px;
    @media (max-width: 600px) {
      height: 35px;
    }
  }
  .input {
    height: 20px;
    @media (max-width: 600px) {
      height: 35px;
    }
  }
  textarea {
    box-shadow: none;
    border-radius: 0px;
    border: none;
    border-bottom: 2px solid ${(props) => props.theme.gray};
    &:focus {
      border-bottom: 2px solid ${(props) => props.theme.orange};
    }
    height: 75px;
    width: 85vw;
  }
`

const Input = ({
  formattedInput,
  onChange,
  name,
  textArea,
  style,
  placeholder,
  label,
  isRequired,
  inline,
  onFocus,
  id,
  type,
  onBlur,
  onClick,
  autoFocus
}) => {
  let Tag = 'input'
  if (textArea) {
    Tag = 'textarea'
  }

  return (
    <Style className="input-component">
      {label && (
        <label htmlFor={name}>
          {label}
          <React.Fragment>{isRequired && <span> *</span>}</React.Fragment>
        </label>
      )}
      {formattedInput ? (
        <NumberFormat
          format="### ### ####"
          className="email-us-modal__phone-number input"
          onChange={onChange}
          placeholder={placeholder}
          name={name}
        />
      ) : (
        <Tag
          onChange={onChange}
          style={style}
          name={name}
          id={id}
          onFocus={onFocus}
          type={type || 'text'}
          required={isRequired}
          placeholder={placeholder}
          onBlur={onBlur}
          onClick={onClick}
          autoFocus={autoFocus}
        />
      )}
    </Style>
  )
}

Input.propTypes = {
  name: PropTypes.string,
  onFocus: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  inline: PropTypes.bool
}
export default Input
